import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES } from '../constants/images';
import { useLanguage } from '../context/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative bg-texture-dark text-cream pt-32 lg:pt-44 pb-32 lg:pb-40 overflow-hidden" data-id="element-98">
      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 left-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-99">
        <span style={{
        writingMode: 'vertical-rl'
      }} className="rotate-180" data-id="element-100">
          {t.hero.sideLeft}
        </span>
        <span className="w-px h-16 bg-cream/15" data-id="element-101" />
      </div>
      <div className="hidden lg:flex absolute top-1/2 -translate-y-1/2 right-8 flex-col items-center gap-6 text-[9px] tracking-[0.5em] uppercase text-cream/35" data-id="element-102">
        <span className="w-px h-16 bg-cream/15" data-id="element-103" />
        <span style={{
        writingMode: 'vertical-rl'
      }} data-id="element-104">
          {t.hero.sideRight}
        </span>
      </div>

      <div className="max-w-[1300px] mx-auto px-8 lg:px-20" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9
      }} className="flex items-center justify-center gap-4 text-[10px] tracking-[0.5em] uppercase text-cream/45 mb-12 lg:mb-16" data-id="element-106">
          <span className="w-12 h-px bg-cream/25" data-id="element-107" />
          <span className="font-serif italic text-caramel normal-case tracking-[0.15em] text-[13px]" data-id="element-108">
            {t.hero.eyebrow}
          </span>
          <span className="w-12 h-px bg-cream/25" data-id="element-109" />
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.1
      }} className="font-serif text-center text-cream font-light leading-[0.88] tracking-[-0.035em]" style={{
        fontSize: 'clamp(64px, 13vw, 200px)'
      }} data-id="element-110">
          {t.hero.title1}
          <br data-id="element-111" />
          <span className="italic font-extralight" data-id="element-112">{t.hero.title2}</span>
          <br data-id="element-113" />
          {t.hero.title3}
          <span className="text-caramel" data-id="element-114">.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1.4,
        ease: [0.22, 1, 0.36, 1],
        delay: 0.4
      }} className="mt-20 lg:mt-28 mx-auto max-w-[640px]" data-id="element-115">
          <div className="text-center mb-6 flex items-center justify-center gap-4 text-[10px] tracking-[0.4em] uppercase text-cream/40" data-id="element-116">
            <span data-id="element-117">{t.hero.plate}</span>
            <span className="w-1 h-1 rounded-full bg-caramel" data-id="element-118" />
            <span data-id="element-119">{t.hero.plateLabel}</span>
          </div>
          <div className="relative" data-id="element-120">
            <div className="absolute -inset-3 border border-cream/15" aria-hidden data-id="element-121" />
            <div className="relative aspect-[4/5] overflow-hidden bg-espresso" data-id="element-122">
              <img src={IMAGES.cheesecake} alt="TARTA signature Basque cheesecake" className="w-full h-full object-cover" data-id="element-123" />
            </div>
          </div>
          <div className="mt-8 text-center max-w-md mx-auto" data-id="element-124">
            <p className="font-serif italic text-cream/70 text-lg lg:text-xl leading-[1.5]" data-id="element-125">
              {t.hero.quote}
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9
      }} className="mt-20 lg:mt-28 flex flex-col items-center gap-8" data-id="element-126">
          <a href="#waitlist" className="group inline-flex items-center gap-6 text-[11px] tracking-[0.4em] uppercase text-cream" data-id="element-127">
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-128" />
            <span className="relative font-serif italic text-[15px] tracking-[0.05em] normal-case" data-id="element-129">
              {t.hero.ctaReserve}
            </span>
            <span className="w-10 h-px bg-cream/40 group-hover:bg-caramel group-hover:w-16 transition-all duration-500" data-id="element-130" />
          </a>
          <a href="https://instagram.com/tartahtx" target="_blank" rel="noreferrer" className="text-[10px] tracking-[0.4em] uppercase text-cream/45 hover:text-caramel transition-colors duration-500" data-id="element-131">
            {t.hero.ctaFollow}
          </a>
        </motion.div>
      </div>
    </section>;
}